var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSolid = function SvgStarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8.371 8.073 2.192-4.348a1.333 1.333 0 0 1 2.372 0l2.196 4.35 4.158.412a1.324 1.324 0 0 1 .821 2.258l-3.457 3.426 1.282 4.66a1.327 1.327 0 0 1-1.876 1.53l-4.31-2.135-4.3 2.13a1.33 1.33 0 0 1-1.434-.156 1.33 1.33 0 0 1-.446-1.372l1.283-4.659-3.46-3.427a1.321 1.321 0 0 1 .809-2.256z",
    clipRule: "evenodd"
  })));
};
export default SvgStarSolid;